if (!customElements.get("loading-screen")) {
    class LoadingScreen extends HTMLElement {
        constructor(){
            super();
            this.el = this.querySelector("#loading");
            this.onDocumentReady((function() {
                this.el.style.display = "none";
            }).bind(this));
        }
        onDocumentReady(callback) {
            if (document.readyState === "complete") // Document is already ready, call the callback immediately
            callback();
            else {
                // Add event listeners for DOMContentLoaded or readystatechange
                document.addEventListener("DOMContentLoaded", callback);
                document.addEventListener("readystatechange", function() {
                    if (document.readyState === "complete") callback();
                });
            }
        }
    }
    customElements.define("loading-screen", LoadingScreen);
}
if (!customElements.get("main-jumbotron")) {
    class Jumbotron extends HTMLElement {
        constructor(){
            super();
            const self = this;
            jQuery(document).ready(function() {
                $(document).mousemove(function(event) {
                    self.paralaxMovement(event, "#lights img", 15, true);
                    self.paralaxMovement(event, "#logo > img", 100, true);
                });
            });
        }
        paralaxMovement(e, selector, offset, opposite) {
            const bgEl = document.querySelector(selector);
            const screenWidth = window.innerWidth;
            const screenHeight = window.innerHeight;
            const mousePosX = e.pageX;
            const mousePosY = e.pageY;
            const maxBgOffset = offset;
            const xPerc = mousePosX / screenWidth * 100;
            const yPerc = mousePosY / screenHeight * 100;
            let xBgOffset = xPerc / 100 * maxBgOffset;
            let yBgOffset = yPerc / 100 * maxBgOffset;
            if (opposite) {
                xBgOffset = -xBgOffset;
                yBgOffset = -yBgOffset;
            }
            bgEl.style.top = `${yBgOffset}px`;
            bgEl.style.marginTop = `${yBgOffset}px`;
            bgEl.style.left = `${xBgOffset}px`;
        }
    }
    customElements.define("main-jumbotron", Jumbotron);
}
if (!customElements.get("google-map")) {
    class GoogleMap extends HTMLElement {
        constructor(){
            super();
            this.google = window.google;
            if (typeof this.google === "undefined") {
                console.error("Error loading Google Maps");
                return;
            }
            this.initialize();
        }
        initialize() {
            const secheltLoc = new this.google.maps.LatLng(-29.8312546, 31.0158101);
            const sechelLang = new this.google.maps.LatLng(-29.8326995, 31.0161494);
            const myMapOptions = {
                zoom: 15,
                scrollwheel: false,
                draggable: false,
                center: sechelLang,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                        "featureType": "landscape",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 65
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 51
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 30
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "lightness": 40
                            },
                            {
                                "visibility": "on"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "stylers": [
                            {
                                "saturation": -100
                            },
                            {
                                "visibility": "simplified"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.province",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "on"
                            },
                            {
                                "lightness": -25
                            },
                            {
                                "saturation": -100
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "hue": "#ffff00"
                            },
                            {
                                "lightness": -25
                            },
                            {
                                "saturation": -97
                            }
                        ]
                    }
                ]
            };
            const theMap = new this.google.maps.Map(document.getElementById("map_canvas"), myMapOptions);
            const marker = new this.google.maps.Marker({
                map: theMap,
                draggable: false,
                scrollwheel: false,
                position: secheltLoc,
                visible: true
            });
            const boxText = document.createElement("div");
            boxText.classList.add("map_text_box");
            boxText.innerHTML = "214 Florida Road \n Windermere \n Durban \n 4001";
            const myOptions = {
                content: boxText,
                disableAutoPan: false,
                maxWidth: 0,
                pixelOffset: new this.google.maps.Size(-96, 0),
                zIndex: null,
                boxClass: "map_box_options",
                closeBoxMargin: "10px 2px 2px 2px",
                closeBoxURL: "http://www.google.com/intl/en_us/mapfiles/close.gif",
                infoBoxClearance: new this.google.maps.Size(1, 1),
                isHidden: false,
                pane: "floatPane",
                enableEventPropagation: false
            };
            this.google.maps.event.addListener(marker, "click", function() {
                ib.open(theMap, this);
            });
            const ib = new InfoBox(myOptions);
            ib.open(theMap, marker);
        }
    }
    customElements.define("google-map", GoogleMap);
}
if (typeof jQuery !== "undefined" || typeof $ !== "undefined") jQuery(document).ready(function() {
    // CLICK TO SCROLL
    $("#home_btn a").click(function() {
        $("html, body").animate({
            scrollTop: 680
        }, 600);
        return false;
    });
    $("#footer_button a").click(function() {
        $("html, body").animate({
            scrollTop: 0
        }, 600);
        return false;
    });
    // Sticky navigation
    $(".nav.navbar-nav a[href^='#']").on("click", function(e) {
        // prevent default anchor click behavior
        e.preventDefault();
        // store hash
        var hash = this.hash;
        // animate
        $("html, body").animate({
            scrollTop: $(this.hash).offset().top
        }, 500, function() {
            // when done, add hash to url
            // (default click behaviour)
            window.location.hash = hash;
        });
    });
    //Sticky Header
    const navpos = $(".navbar").offset();
    $(window).bind("scroll", function() {
        if ($(window).scrollTop() > navpos.top) $(".navbar").addClass("fixed");
        else $(".navbar").removeClass("fixed");
    });
    $(".fancybox").fancybox();
    if (window.innerWidth <= 990) {
        $("#page .row").children().unwrap();
        $("#page .col-md-4").children().unwrap();
        $("#page .item").children().unwrap();
        const allArticles = $("#page .news_panel, #gallery_page .gallery_panel");
        allArticles.each(function(index) {
            let activeClass = "";
            if (index === 0) activeClass = "active";
            $(this).wrap('<div class="item ' + activeClass + '"></div>');
        });
        $("#gallery_page .row").children().unwrap();
        $("#gallery_page .col-sm-2").children().unwrap();
        $("#gallery_page .item").children().unwrap();
        $("#gallery_page .gallery_panel").children().unwrap();
        const allImages = $("#gallery_page .img-responsive");
        allImages.each(function(index) {
            let activeClass = "";
            if (index === 0) activeClass = "active";
            $(this).wrap('<div class="item ' + activeClass + '"></div>');
        });
    }
});

//# sourceMappingURL=index.6455747f.js.map
